import { Component, HostListener } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MenuItem, SortEvent } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UsersService } from './users.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { ExceldownloadComponent } from 'src/app/views/directives/exceldownload/exceldownload.component';
import { UploadexcelformatComponent } from 'src/app/views/directives/uploadexcelformat/uploadexcelformat.component';
//import { Entityservice } from '../entity/entityservice';
// import { Verticalservice } from '../vertical/verticalservice.service';
// import { DepartmentService } from '../department/department.service';
// import { LocationService } from '../location/location.service';
import { Utilityservice } from '../../utility/utilityservice.service';
import { GlobalMessage, Users } from '../../utility/modals';
import { UsermodalComponent } from '../../directives/usermodal/usermodal.component';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
import { BulkexceluploadComponent } from '../../directives/bulkexcelupload/bulkexcelupload.component';
@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent {

  items: MenuItem[] | undefined;
  selectedItem: MenuItem | null = null;
  tableData: any[] = [];
  isDropdownOpen = false;
  userslist: any;
  userslistarray: Array<Users> = [];

  userUpdatereq: Users = new Users();
  ref: DynamicDialogRef | undefined;
  deptlist: Array<any>;
  commonScrollHeight = '';
  tempuse: any;
  first2: number = 0;
  rows2: number = 10;
  totalRecords: number = 0;
  visible: boolean = false;
  options = [{ label: 10, value: 10 }];
  paginatorArray = [];
  psition = 'top';
  productlist = [];
  entitylist = [];
  locationList = [];
  departList = [];
  verticalList = []
  filterinput = {
    tproduct: '',
    tentity: '',
    tlocation: '',
    tdepartment: '',
    tvertical: '',
    tstatus: '',
    torganisation: ''
  }
  cols = [];
  CSRFToken = "";
  _selectedColumns = [];
  activestatus = [];
  excel_paragraph = '';
  templatedownloadtext = '';
  exceldownloadModal = false;
  downloadformate = false;
  organisationList = [];
  message: GlobalMessage = new GlobalMessage();
  selectedOrgId: string = '';
  isNormalAdmin: String = "Ydfv";
  userId: number;
  parentdata: any;
configparams:any
  constructor(
    private userdashboardService: UsersService,
    public router: Router, private fb: FormBuilder,
    public dialogService: DialogService, private userService: UsersService,
    public utilityservice: Utilityservice, public PagehelpmodalService: PagehelpmodalService
  ) {
    this.excel_paragraph = this.message.downloadexcel_text;
    this.templatedownloadtext = this.message.excelformate_text
     this.utilityservice.fetchAndStoreConfigParams()
       this.utilityservice.configParams$.subscribe(res => {
       this.configparams=res;  
           if (this.configparams?.requirevertlabel == "Y") {
          this.getVerticallist();
        }   

      })
  }
  //
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
  }
  ngOnInit() {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
    this.getParams2()
    this.dynamiccols();
    this.getDistinctProduct();
    this.getdepartmentlist();
    this.getlocationforlist();
    this.getentityList();
    this.getConfiguration();

    this.getStatusList();



    // this.activestatus = [
    //   {
    //     'labelname': 'Active',
    //     'value': 'Y'
    //   },
    //   {
    //     'labelname': 'Inactive',
    //     'value': 'N'
    //   }
    // ]
  }
  threelocktooltip=`If a user has not logged in for three months, the account will be automatically locked. An administrator must unlock the account to restore access. `
  locktooltip=`If a user enters the maximum number of incorrect passwords, the account will be locked. An administrator must unlock it to restore access. `
sortorder=1;
sortfield='username'
  dynamiccols() {
    this.cols = [
      { field: 'userid', header: 'ID', type: 'text', sort: true, filter: true, width: '2px !important', isChecked: true, class: 'headerid' },
      { field: "username", header: "User Name", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "email", header: "Email", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "rolename", header: "Role", type: 'text', sort: false, filter: false, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "departmentname", header: "Department", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "locationname", header: "Location", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "createdon", header: "Created On",type:'text',sort: true ,width:'20px',isChecked:true,class:'otherheader',filter:true } ,
      { field: "createdby", header: "Created By",type:'text',sort: false ,width:'20px',isChecked:true,class:'otherheader',filter:true } ,
      { field: "activeflag", header: "Status", type: 'text', sort: false, filter: false, width: '20px', isChecked: true, class: 'otherheader' }
    ]
    this._selectedColumns = this.cols;
    console.log(this.authType,"this.authType");
    
    
  }
  getParams2() {
    this.getusers(this.sortorder,this.sortfield);

  }
  refreshFilters() {
    this.filterinput.tdepartment = '';
    this.filterinput.tstatus = '';
    this.filterinput.tproduct = '';
    this.filterinput.tlocation = '';
    this.filterinput.tvertical = '';
    this.filterinput.tentity = '';
    this.filterinput.torganisation = '';

    this.getusers(this.sortorder,this.sortfield);

  }
  onMenuItemClick(event: any): void {
    this.selectedItem = event.item;
    if (this.selectedItem.command) {
      this.selectedItem.command();
    }
  }

  excelName: string;
  downloadApi: string;
  methodType: string;
  buttonName: string = "";
  modalHeight: string = "10rem";
  modalWidth: string = "";
  showDialog(type) {
    let payload = { ...this.filterinput };
    if (type == "excelDownload") {
      this.excelName = "Users_Master_Data.xlsx";
      this.downloadApi = 'common/user/userdashboardExcel';
      this.methodType = 'post';
      this.buttonName = "";
      this.modalWidth = "60vw";
      this.modalHeight = "auto";
    }
    if (type == "lockData") // backend pending
    {
      this.excelName = "User Lock Log Data.xlsx";
      this.downloadApi = 'common/user/threemonthlockdataExcel';
      this.methodType = 'post';
      this.buttonName = "";
      this.modalWidth = "60vw";
      this.modalHeight = "auto";


    }
    if (type == "mappedDataDownload") // backend pending - main excel 
    {
      this.excelName = "User-Details.xlsx";
      this.downloadApi = 'common/user/excelmappedata';
      this.methodType = 'post';
      this.buttonName = this.lastSyncDate;
      this.modalHeight = "20rem";
      this.modalWidth = "45vw";
      this.excel_paragraph=`The data will be saved in your Download directory by default. Please check for the latest file that is downloaded since Excel does a version control if the file with the same name exists.`
    }
    // superadminexcel
     if (type == "super") // backend pending - main excel 
    {
      this.excelName = "SuperAdmin-User-Details.xlsx";
      this.downloadApi = 'common/user/superadminexcel';
      this.methodType = 'post';
      this.buttonName = this.lastSyncDate;
      this.modalHeight = "20rem";
      this.modalWidth = "45vw";
      this.excel_paragraph=`The data will be saved in your Download directory by default. Please check for the latest file that is downloaded since Excel does a version control if the file with the same name exists.`
    }

    const width = this.utilityservice.isMobile() ? '90vw' : 'auto';
    this.ref = this.dialogService.open(ExceldownloadComponent, {
      header: "Excel Download",
      width: this.modalWidth,
      height: this.modalHeight,
      data: { excelname: this.excelName, downloadapi: this.downloadApi, method: this.methodType, message: this.excel_paragraph, payload: payload, requireButton: this.buttonName, orgId: this.orgId, userId: this.userId },
      contentStyle: { overflow: 'hidden' },
      baseZIndex: 10000,
    });
  }
left='left'
  closedpop() {
    this.visible = false
  }
 ngOnDestroy() {
  if (this.ref) {
    this.ref.close();
  }
}



  getusers(order,sortfield) {
       const filterobj=this.sanitizeFilter(this.filterinput)
    this.userdashboardService.getall_users(filterobj).subscribe((data) => {

      this.userslist = data;
      this.userslistarray = this.userslist;
      this.options = this.userService.getOptionDropdown(data.length);
      this.options = this.userService.getOptionDropdown(data.length);
      this.paginatorArray = this.options.map(e => e.value)
          this.userslistarray= this.userslist.map((item: any) => ({
            ...item,
  createdon: item.createdon ? this.convertToDateString(item.createdon) : ''
}));  
      this.userslistarray.map(e => {
        e['isSelect'] = false
      })
      this.totalRecords = this.userslistarray.length;
      this.sortorder=order;
this.sortfield=sortfield
    });

  }

  show(title, data) {
    let details = {};
    let extraDetails = {};
    const payload={
      userid:data.userid
    }
    if (title === 'Modify User' || title == 'Mapped Module') {
      extraDetails =
      {
        "modalType": "Modify",
        "orgType": this.orgType,
        "isNormalAdmin": this.isNormalAdmin,
        "isBusinessUser": this.isBusinessUser,
        "isBusinessUserRequired": this.isBusinessUserRequired,
        "currentNumberOfBusinessUsers": this.currentNumberOfBusinessUsers,
        "numberOfBusinessUsers": this.numberOfBusinessUsers,
        "authType": this.authType
      }
      if(this.utilityservice.getLoggeduser().orgid==0 && this.filterinput.torganisation!=='' && this.filterinput.torganisation!==null){
     payload['orgid']=this.filterinput.torganisation
      }
      this.userService.getUserDataView_byId(payload).subscribe((res: any) => {
        if (res.length === 0) {
          // Show swal notification here
          Swal.fire({
            icon: 'error',
            title: 'Data Error',
            text: 'Data is null',
          });
        } else {
          details = res;
          this.ref = this.dialogService.open(UsermodalComponent, {
            header: title,
            width: '95%',
            height: 'auto',
            maximizable:true,
            data: { title: title, datas: { list: details, userid: data.userid },filters:this.filterinput ,extraDetails: extraDetails},
            contentStyle: { overflow: 'hidden' }
          });
          this.ref.onClose.subscribe((res) => {
            if(res=='Save'){
                  this.getusers(this.sortorder,this.sortfield);

            // this.getusers(-1,'createdon');
          }

          });
        }
      });
    }
    else if (title === "Emergency Stop") {
      Swal.fire({
        title: "This action will temporarily disable logins for all the users except administrator. Are you sure you want to do it?",
        text: "Please confirm.",
        showDenyButton: true,
        confirmButtonText: "Yes, I am sure!",
        denyButtonText: `No, cancel it!`
      }).then((value) => {
        if (value.isConfirmed) {
          this.utilityservice.getCSRFtoken().subscribe(
            res => {
              const payload = {
                csrftoken: res.csrf,
              };
              this.userService.emergencyStop(payload).subscribe({
                next: () => {
                  const payload = {
                    csrftoken: this.CSRFToken,
                  };
                  Swal.fire("Saved!", "Your changes have been saved.", "success");
                  window.location.reload();
                },
                error: (error) => {
                Swal.fire(error.error.message, '', 'error');
                }
              });
            },
            err => {
              Swal.fire(err.error.message || "CSRF Token Error", '', 'error');
            }
          );
        }
      });
    }
    else if (title === "Emergency Start") {
      Swal.fire({
        title: "Are you sure you want to enable user's login?",
        text: "Please confirm.",
        showDenyButton: true,
        confirmButtonText: "Yes, I am sure!",
        denyButtonText: `No, cancel it!`
      }).then((value) => {
        if (value.isConfirmed) {
          this.utilityservice.getCSRFtoken().subscribe(
            res => {
              const payload = {
                csrftoken: res.csrf,
              };
              this.userService.emergencyStart(payload).subscribe({
                next: () => {
                  const payload = {
                    csrftoken: this.CSRFToken,
                  };
                  Swal.fire("Saved!", "Your changes have been saved.", "success");
                  window.location.reload();
                },
                error: (error) => {
                  console.error('Error response:', error);
                Swal.fire(error.error.message, '', 'error');
                }
              });
            },
            err => {
              Swal.fire(err.error.message || "CSRF Token Error", '', 'error');
            }
          );
        }
      });
    }


    else {
      
        if (this.numberOfUsers <= this.currentNumberOfusers) {
                     Swal.fire({
                      icon: 'warning',
                      title: 'Maximum Allowed Users Used',
                      text: 'Please Contact Complinity Helpdesk'
                    })
                  } 
         else{
      details = {};
      extraDetails =
      {
        "modalType": "Add",
        "orgType": this.orgType,
        "isNormalAdmin": this.isNormalAdmin,
        "isBusinessUser": this.isBusinessUser,
        "isBusinessUserRequired": this.isBusinessUserRequired,
        "currentNumberOfBusinessUsers": this.currentNumberOfBusinessUsers,
        "numberOfBusinessUsers": this.numberOfBusinessUsers,
        "authType": this.authType,
        "currentNumberOfUsers": this.currentNumberOfusers,
        "numberOfUsers": this.numberOfUsers,
      }
      //alert(JSON.stringify(extraDetails));

      this.ref = this.dialogService.open(UsermodalComponent, {
        header: title,
        width: '95%',
        height: 'auto',
        maximizable:true,
        data: { title: title, datas: details, extraDetails: extraDetails },
        contentStyle: { overflow: 'hidden', }
      });
      this.ref.onClose.subscribe((res) => {
        if(res=='Save'){
            this.getusers(-1,'createdon');
          }
      });}
    }
  }

  excelUploadFormat() {
    if (this.isBelowUserLimit != "Y") {
      Swal.fire('Maximum Allowed Users Used', 'Please Contact to Complinity Helpdesk', 'error');
    }
    else {
      this.userService.excelUploadFormat().subscribe((response: Blob) => {
        const blob = new Blob([response],
          { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Users_Data_Format.xlsx';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        this.downloadformate = false;
        Swal.fire('Excel File Downloaded ', '', 'success');
      }, error => {
              Swal.fire(error.error.message, '', 'error');

      });
    }
  }
  getProductList(payload) {
    this.userService.getproductforlist(payload).subscribe(res => {
      this.productlist = res;
    })
  }
  getentityList() {
    //this.entityservice.getentityforlist().subscribe(res => {
    this.userService.getDistinctEntity().subscribe(res => {

      this.entitylist = res;
            this.entitylist.unshift({companyname:'Select',companyid:''})

    })
  }
  getdepartmentlist() {
    //this.depservice.getdepartmentforlist().subscribe(res => {
    this.userService.getDistinctDepartment().subscribe(res => {

      this.departList = res;
            this.departList.unshift({departmentname:'Select',departmentid:''})

    })
  }
  getlocationforlist() {
    // this.locservice.getlocationforlist().subscribe(res => {
    this.userService.getDistinctLocation().subscribe(res => {

      this.locationList = res;
      this.locationList.unshift({locationname:'Select',locationid:''})
    })
  }
  getVerticallist() {
    //this.verticalservice.getall_list().subscribe(res => {
    this.userService.getDistinctVertical().subscribe(res => {

      this.verticalList = res;
      this.verticalList.unshift({name:'Select',verticalid:''})

    })
  }

  getStatusList() {
    //this.verticalservice.getall_list().subscribe(res => {
    this.userService.getDistinctStatus().subscribe(res => {

      this.activestatus = res;
      this.activestatus.unshift({labelname:'Select',activeflag:''})
    })
  }
  showUploadFormatDialog() {
    this.ref = this.dialogService.open(UploadexcelformatComponent, {
      header: "Download Excel Format",
      data: {},
      contentStyle: { overflow: 'hidden' },
      baseZIndex: 10000,
      maximizable: true,
      position: 'top'
    });
    this.ref.onClose.subscribe(() => {
      // this.commonservice.downloadObservable.next("")
    });
  }

  handlePageChange(event: any) {
    this.rows2 = event.rows
  }

  currentNumberOfusers: number;
  numberOfUsers: number;
  numberOfBusinessUsers: number;
  orgType: String;
  userRole: number;
  orgId: number;
  limitedAccess = "";
  currentNumberOfBusinessUsers: number;

  isBusinessUser = "";
  emergencyFlag = "";
  lockFlag = "";
  isOrgAdmin = "";
  isSupportAdmin = "";
  lastSyncDate = "";

  conditionValidator = "";
  excelUploadValidator = "";
  emergencyValidator = "";
  isBusinessUserRequired = "";
  isVerticalRequired = "";
  verticalLabel = "";
  authType = "";
  // descided wheter to allow to add via excel
  isBelowUserLimit = "Y";




issuperadmin=false;
  getConfiguration(): void {
    this.userService.getConfiguration().subscribe(
      (response) => {
        if (response && response.length > 0) {
          this.userRole = Number(response[0]?.userRole);
          console.log(this.userRole, typeof this.userRole);
          if(this.userRole===0){
            this.issuperadmin=true
          }
          this.verticalLabel = response[0]?.verticalLabel;
          this.isVerticalRequired = response[0]?.isVerticalRequired;
          this.currentNumberOfusers = response[0]?.currentNumberOfusers;
          this.numberOfUsers = response[0]?.numberOfUsers;
          this.isBusinessUser = response[0]?.isBusinessUser;
          this.limitedAccess = response[0]?.tssprtlimitedaccess;
          this.emergencyFlag = response[0]?.emergencyFlag;
          this.lockFlag = response[0]?.lockFlag;
          this.orgType = response[0]?.orgType;
          this.isOrgAdmin = response[0]?.isOrgAdmin;
          this.isSupportAdmin = response[0]?.isSupportAdmin;
          this.isBusinessUserRequired = response[0]?.isBusinessUserRequired;
          this.currentNumberOfBusinessUsers = response[0]?.currentNumberOfBusinessUsers;
          this.numberOfBusinessUsers = response[0]?.numberOfBusinessUsers;
          this.authType = response[0]?.authType;
          this.orgId = Number(response[0]?.orgId);
          this.lastSyncDate = response[0]?.lastSyncDate;
          this.userId = response[0]?.userId;
        }

        if (this.isSupportAdmin == 'Y' || this.isOrgAdmin == 'Y') {
          this.isNormalAdmin = "N";
        }
        if (this.limitedAccess == 'N' && this.isBusinessUser == 'N') {
          this.conditionValidator = "noAccessRestrictions";
        }
        if (this.emergencyFlag == "Y") {
          if (this.lockFlag == "0" || this.lockFlag == "N") {
            this.emergencyValidator = "lockAllExceptAdmin"
          }
          else {
            this.emergencyValidator = "unlockAll"
          }
        }

        if (this.limitedAccess == 'N' && this.isBusinessUser == 'Y' && this.userRole == 1) {
          this.conditionValidator = "adminBusinessUserRequired";
        }


        if (this.userRole == 0) {
          this.getOrganisation();
        }

        // if (this.configparams?.requirevertlabel == "Y") {
        //   this.getVerticallist();
        // }

        if (this.limitedAccess == "N" && this.userRole == 1) {
          this.excelUploadValidator = "Allow";
          if (this.currentNumberOfusers < this.numberOfUsers) {
            this.isBelowUserLimit = "Y";
          }
        }
        if( this.authType=="AD"){
      this.cols.splice(1,0,
              { field: 'loginid', header: 'login ID', type: 'text', sort: true, filter: true, width: '2px !important', isChecked: true, class: 'headerid' },

      )
    }
      },
      (error) => {
        console.error('Error fetching configuration:', error);
      }
    );
  }

  getOrganisation() {
    this.userService.getOrganisation().subscribe(res => {
      this.organisationList = res;
      this.organisationList.unshift({ orgid: '', name: 'Select' });
    });
  }

  // used in main layout filter
  getDistinctProduct() {
    this.userService.getDistinctProduct().subscribe(res => {
      this.productlist = res;
      this.productlist.unshift({productname:'Select',productid:''})
    })
  }
  gettoken() {
    this.CSRFToken = '';
    this.utilityservice.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    }, error => {
      Swal.fire(error.error.message, '', 'error');
    });
  }

  onOrgChange(orgId: string) {
    this.selectedOrgId = orgId;
    this.filterinput.torganisation = orgId;
    this.getusers(this.sortorder,this.sortfield);
  }

  getSelectedProduct(): string {
    if (!this.filterinput.tproduct) return 'Select Product';
    const selected = this.productlist.find(item => item.productid === this.filterinput.tproduct);
    return selected ? selected.productname : 'Select Product';
  }

  getSelectedEntity(): string {
    if (!this.filterinput.tentity) return 'Select Entity';
    const selected = this.entitylist.find(item => item.companyid === this.filterinput.tentity);
    return selected ? selected.companyname : 'Select Entity';
  }

  getSelectedLocation(): string {
    if (!this.filterinput.tlocation) return 'Select Location';
    const selected = this.locationList.find(item => item.locationid === this.filterinput.tlocation);
    return selected ? selected.locationname : 'Select Location';
  }

  getSelectedDepartment(): string {
    if (!this.filterinput.tdepartment) return 'Select Department';
    const selected = this.departList.find(item => item.departmentid === this.filterinput.tdepartment);
    return selected ? selected.departmentname : 'Select Department';
  }

  getSelectedVertical(): string {
    if (!this.filterinput.tvertical) return 'Select ' + this.configparams.vertlabelname;
    const selected = this.verticalList.find(item => item.verticalid === this.filterinput.tvertical);
    return selected ? selected.name : 'Select  ' +  this.configparams.vertlabelname;
  }
  
  getSelectedStatus(): string {
    if (!this.filterinput.tstatus) return 'Select Status';
    const selected = this.activestatus.find(item => item.activeflag === this.filterinput.tstatus);
    console.log(selected);
    
    return selected ? selected.labelname : 'Select Status' ;
  }
   convertToDateString(dateValue: any): string {
  if (!dateValue) return '';
  
  const date = new Date(dateValue);
  if (isNaN(date.getTime())) return '';

  // Format as "dd-MMM-yyyy"
  const day = String(date.getDate()).padStart(2, '0');
  const month = date.toLocaleString('en-US', { month: 'short' });
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}

  openexceluploadmodal() {
    let payload = {}
    this.parentdata = {};
    
    this.parentdata = {
      title: 'User Data Upload',
      apdownloadapi: 'common/user/uploadexcel',
      sucessmessage: 'User Data uploaded successfully!',
      master: 'Users',
      message:`You should have downloaded the Excel format for Users creation. You should have updated all the required information. The Excel file you choose will be uploaded and verified for accuracy. If there are no errors, the hierarchies will be created. Else, the errors will be displayed on the screen.`
      
    }
    this.ref = this.dialogService.open(BulkexceluploadComponent, {
      header: this.parentdata.title,
      width: '70%',
      height: '40',
      data: {
        uploadapi: this.parentdata.apdownloadapi,
        method: 'Post', message: this.parentdata.message, payload: payload, master: this.parentdata.master,successmessage:this.parentdata.sucessmessage
      },
      contentStyle: { overflow: 'hidden' },
      position: 'center',
      style: { 'max-width': '100%', 'min-width': '60%' }
    }),
      this.ref.onClose.subscribe(res => {
        if (res == 'uploaded') {
            this.getusers(-1,'createdon');
        }
      })
  }

 sanitizeFilter(data) {
  Object.keys(data).forEach(key => {
    if (data[key as keyof FilterData] == null) {
      data[key as keyof FilterData] = '';
    }
  });
  return data;
}


}
export class FilterData{
   tproduct: ''
    tentity: ''
    tlocation: ''
    tdepartment: ''
    tvertical: ''
    tstatus: ''
    torganisation: ''
 }






